export default __webpack_public_path__ + "static/setup_ide-930fd31092c4cd217f92d6f5d1bcf272.png";